export const blockIconsHardwareHeadset = (
	<span className='material-symbols-outlined'>headset</span>
);
